var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCsoAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cso-analytics-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Extra-Large-Copy",
    transform: "translate(-589, -342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(600, 354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.224405,51.2279904 C41.61635,60.8175313 26.7639443,62.7654046 15.0060187,55.9779837 C3.24809319,49.1905629 -2.48647035,35.3585843 1.02197863,22.2479637 C4.53042761,9.13734311 16.4079397,0.0139166418 29.9859275,0 L29.9859275,16.3712429 C23.8233208,16.3896285 18.4391232,20.5373803 16.8517684,26.4892279 C15.2644136,32.4410756 17.8685484,38.7172764 23.2042693,41.7993307 C28.5399902,44.881385 35.2807352,44.0030353 39.6475767,39.6566931 L51.224405,51.2279904 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9999267,29.9996598 C60.017546,37.9610519 56.859275,45.6010332 51.224405,51.2279904 C49.116969,49.1215613 47.536392,47.5417394 46.482674,46.4885248 C44.9955243,45.0020857 42.7647999,42.7724269 39.7905005,39.7995486 C42.3227273,37.1735652 43.7015267,33.6459365 43.6208585,29.9996598",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9999267,29.9996598 L43.6208585,29.9996598 C43.6051347,22.4794125 37.5097693,16.3869592 29.9859275,16.3712429 L29.9859275,0 C46.5622015,0 59.9999267,13.4313052 59.9999267,29.9996598 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.164435,
    y1: 41.2221918,
    x2: 49.4102671,
    y2: 49.3756777,
    id: "Path-3",
    stroke: "#10575D",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9860866,36.8673157 C40.5790323,39.3567437 38.642354,41.117551 36.176052,42.1497376",
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.628855,48.5108596 C51.7993227,50.6509104 49.9697904,52.4454256 48.1402581,53.8944051",
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsoAnalyticsIcon);
export default __webpack_public_path__ + "static/media/cso-analytics-icon.abd82183820a88b54be117ae86507ead.svg";
export { ForwardRef as ReactComponent };